import { concave, destination, point, featureCollection } from '@turf/turf'
import type { Feature, Point } from 'geojson'

const SAMPLES_PER_POINT = 8
const BASE_RADIUS_M = 3

export function computeUncertaintyCorridor(
  rawCoords: GeoJSON.Position[],
  tags?: ('moving' | 'rest' | 'vehicle')[]
): GeoJSON.Position[] {
  if (rawCoords.length < 3) return []

  const samples: Feature<Point>[] = []
  const radiusKm = BASE_RADIUS_M / 1000

  for (let i = 0; i < rawCoords.length; i++) {
    if (tags && tags[i] !== 'moving') continue
    const center = point([rawCoords[i][0], rawCoords[i][1]])

    for (let j = 0; j < SAMPLES_PER_POINT; j++) {
      const angle = (j / SAMPLES_PER_POINT) * 360
      samples.push(destination(center, radiusKm, angle))
    }
  }

  if (samples.length < 3) return []

  const fc = featureCollection(samples)
  const hull = concave(fc, { maxEdge: 0.05, units: 'kilometers' })

  if (!hull) return []

  if (hull.geometry.type === 'Polygon') {
    return hull.geometry.coordinates[0]
  }
  if (hull.geometry.type === 'MultiPolygon') {
    let largest = hull.geometry.coordinates[0][0]
    for (const poly of hull.geometry.coordinates) {
      if (poly[0].length > largest.length) largest = poly[0]
    }
    return largest
  }

  return []
}
